import dialogMixin from "./dialog";
export default {
  mixins: [dialogMixin],
  computed: {
    title() {
      return (this.isEdit ? "修改" : "创建") + " " + this.unit;
    }
  },
  data() {
    return {
      isEdit: false
    }
  }
}